function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransportationTrainFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.888 18.459a1.619 1.619 0 113.237-.001 1.619 1.619 0 01-3.237 0zm8.933 0a1.619 1.619 0 113.237-.001 1.619 1.619 0 01-3.237 0zm-7.995 6.729l1.433-1.614h7.429l1.433 1.614H10.826zm-2.285-3.614h14.865V15.01H8.541v6.563zm0-14.426h14.865V5.574H8.541v1.574zm8.432 5.862h6.433V9.148h-6.433v3.862zm-8.432 0h6.433V9.148H8.541v3.862zm13.823 10.564h2.042a1 1 0 001-1v-18a1 1 0 00-1-1H7.541a1 1 0 00-1 1v18a1 1 0 001 1h2.042L5.21 28.5h2.675l1.165-1.312h13.847l1.165 1.312h2.675l-4.373-4.926z",
    fill: props.color
  }));
}

export default SvgIconTransportationTrainFilled;